import React from 'react';
import * as FPT from '../utility/fpt';
import AppStore from '../stores/AppStore';
import TemplateData from '../utility/getTemplateData';
import { isExternalFlow } from '../utility/externalIntegrationUtils';
import { EVENT_NAME } from '../utility/constants';

const PAGE_TRACK_TAG = 'main:donate:wps:';

export default function withPageTrack(WrappedComponent, flow, result) {
  return class extends React.Component {
    componentDidMount() {
      const confData = AppStore.getConfirmation() || {};
      const isSignUp = confData.showAccountOverview || false;

      if (isSignUp || TemplateData.fptPageName === 'guestULSignUp') {
        flow = 'signup';
      }

      let tag = `${PAGE_TRACK_TAG}${flow}:${result}`;
      const fptiPayload = {
        trid: confData.confirmationNumber || '',
        account_type: flow,
        amount: confData.postBackData?.mc_gross,
        currency: confData.postBackData?.mc_currency,
      };
      FPT.trackToken();
      if (isExternalFlow()) {
        FPT.trackExternalFlowData();
        fptiPayload.event_name = confData.isOfacPending
          ? EVENT_NAME.DW_GIVING_PAYMENT_PENDING_SCREEN_SHOWN
          : EVENT_NAME.DW_GIVING_PAYMENT_SUCCESS_SCREEN_SHOWN;
        FPT.trackPageWithData(tag, `${tag}:web::`, fptiPayload);
      } else {
        FPT.trackPageWithData(tag, `${tag}:web::`, fptiPayload);
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };
}
